import cfastiedata from "./raw/cfastie.json";

export const cFastieColorMap = (type) => {
  if (type === "range") {
    return cfastiedata;
  }
};
